import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData, getTablebySql } from "@shared/utils/CommonUtils";
import { global, globalMenu } from "@shared/libs/Global";
import ExcelUpload from "@widgets/commonpopup/ExcelUpload";
import { showPopupModal } from "@widgets/CommonModal";
import SharedForm from "../../../../../widgets/SharedForm";
import { fnSave } from "@shared/api/restApi";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "src/widgets/CommonDialog";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { dateToString } from "@shared/utils/DateUtils";
import SnFileHelper from "@shared/components/SnFileHelper";

interface Props {
  Menuprops: menuInfo;
}

const SN_MTL_PTY_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();
  const fileHelperRef = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    sheet1: React.createRef(),
  });
  const sharedFormRef1 = useRef<any>();

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    sheet1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    sheet1: [],
  });
  const [sharedForm, setSharedForm] = useState<any[]>([]);

  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [cdIoList, setCdIoList] = useState<any[]>([]); // onValueChaged 함수에서 수불형태 비교용 데이터

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onExcelUpload,
    onExcelDownLoad,
    onPrint,
  }));

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setSharedForm(rtn.form.freeform1);
        setColums({
          grid1: rtn.grid.grid1,
          sheet1: rtn.grid.sheet1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const modifiedRows = gridRefs.current["grid1"].current.getChange();
      if (modifiedRows.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirm",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm) {
          const isSaved = await onSave();
          if (!isSaved) return;
        }
      }

      const params = {
        id: "sn_mtl_pty_reg_001_01",
        params: searchRef.current.getFormdata(),
      };

      setFocusedRowData(null);
      gridRefs.current["grid1"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        sheet1: data[1] || [],
      });
    } catch (error: any) {}
  };

  const onInsert = () => {
    const searchFormData = searchRef.current.getFormdata();
    const selectedData = {
      tp_property: searchFormData.tp_property,
      st_property: searchFormData.st_property,
    };
    let tp_prop = selectedData.tp_property;
    let st_prop = selectedData.st_property;
    const newRow = {
      cd_firm: userInfo.cd_firm,
      dt_pur: dateToString(new Date()),
      st_property: "STOCK",
      cd_emp: "",
      cd_location: "",
      tp_property: tp_prop ? tp_prop : "top1",
    };
    gridRefs.current["grid1"].current?.addRow(newRow);
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current.getDisplayedRowCount() < 1) return;

    const focusedRowNode = gridRefs.current["grid1"]?.current.focusedRowNode();
    let rowIndex: any = 0;
    if (focusedRowNode) rowIndex = focusedRowNode.rowIndex;

    gridRefs.current["grid1"].current?.deleteSelectedRows();
    if (rowIndex === 0) {
      setFocusedRowData(null);
    } else {
      const newRowIndex = rowIndex === 0 ? 0 : rowIndex - 1;
      gridRefs.current["grid1"].current?.selectAndFocusRow(newRowIndex);
    }
  };

  const onSave = async () => {
    let propertyChanges;
    try {
      gridRefs.current["grid1"].current.stopEditing();

      const requiredValuesCheck =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheck) return false;

      propertyChanges = gridRefs.current["grid1"].current.getChange();
      if (propertyChanges.modifiedRowcount == 0) {
        await showDialog("alter", "저장할 내용이 없습니다.");
        return false;
      }

      const saveData = {
        property: propertyChanges,
      };
      const ok = await fnSave("SN_MTL_PTY_REG_001_SAVE_01", saveData);
      if (!ok) return false;

      gridRefs.current["grid1"].current.resetUpdate();
      //sharedFormRef1.current["freeform1"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      //sharedFormRef1.current["freeform1"].current.resetUpdate(true);
      return false;
    }
  };

  const onPrint = async () => {
    const grid1 = gridRefs.current["grid1"].current;
    grid1?.stopEditing();

    const node = grid1?.focusedRowNode();
    if (!node || !node.data || !node.data.cd_property) {
      await showDialog("alert", "선택된 정보가 없습니다.");
      return;
    }

    return {
      cd_firm: userInfo.cd_firm,
      cd_property: node.data.cd_property,
    };
  };

  const onExcelUpload = async () => {
    try {
      const component = (
        <ExcelUpload
          Menuprops={Menuprops} // 메뉴 정보 전달
          PkFields={["cd_property"]} // PK 필드 목록 전달
          tableName="property" // 저장할 테이블 이름
          controllerName="SN_MTL_PTY_REG_001_SAVE_01" // 저장할 컨트롤러 이름
        />
      );

      const result = await showPopupModal({
        title: "엑셀 업로드",
        children: component,
        width: "80%",
        height: "90VH",
        okayBtnText: "저장",
      });

      if (result?.excelUpload) {
        await onSearch();
      }

      if (result) {
        console.log("엑셀 업로드 완료:", result);
      } else {
        console.log("엑셀 업로드 취소됨");
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  // 엑셀 다운로드 핸들러

  const onExcelDownLoad = async () => {
    try {
      // 1) gridRefs.current["grid1"]에서 (필터/정렬 반영)된 행만 수집
      const rows: any[] = [];
      gridRefs.current["grid1"].current?.forEachFilteredNode((node: any) => {
        if (node?.data) rows.push(node.data);
      });

      // 2) gridRefs.current["sheet1"] 초기화 후 주입 (⚠ SnGrid는 setRowData 없음)
      gridRefs.current["sheet1"].current?.deleteAllRows?.(); // SnGrid가 제공하는 삭제 헬퍼
      gridRefs.current["sheet1"].current?.applyTransaction({
        add: rows.map((r) => ({ ...r })), // 깊은 복사 권장
      });

      // 3) “보이는 컬럼만” export 키 생성 (숨김 제외)
      const displayedCols =
        gridRefs.current["sheet1"].current?.getAllDisplayedColumns() || [];
      const columnKeys = displayedCols.map((c: any) => c.getColId());

      // 4) Excel Export: processCellCallback으로 “라벨 우선” 매핑
      gridRefs.current["sheet1"].current?.exportDataAsExcel({
        columnKeys,
        skipPinnedBottom: true,
        fileName: `${globalMenu.getState().activeMenuInfo.nm_menu}.xlsx`,
        sheetName: "Sheet1",
        // onExcelDownLoad 내부 exportDataAsExcel({...})의 processCellCallback 만 교체
      });
    } catch (e: any) {
      showDialog("error", e?.message || "Excel 다운로드 오류");
    }
  };

  const handleFileUploadSuccess = async (
    fileName: string,
    isUpload: boolean
  ) => {
    const focusedRowNode = gridRefs.current["grid3"].current.focusedRowNode();

    if (focusedRowNode.length) {
      await showDialog("alter", "먼저 행을 선택하세요.");
      return;
    }

    if (focusedRowNode) {
      focusedRowNode.setDataValue("nm_file", fileName);
      if (!isUpload) {
        onDelete();
      }
    }
  };

  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
    },
    [focusedRowData]
  );

  const onValueChaged = async (data: any, param: string, formData: any) => {
    switch (param) {
      // 거래구분
      case "dt_dispose":
        if (data !== "" && data !== null) {
          return { st_property: "DISPOS", cd_location: "DISPOS" };
        } else {
          return {};
        }
      default:
        return {};
    }
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
        },
      },
      sheet1: {
        columns: columns.sheet1,
        dataSource: dataSources.sheet1,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="w-full flex h-full min-h-0 space-x-1.5">
        <SnResizeBar direction={"width"} id="panel1" orgSize="23.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "비품정보",
              isEditable: false,
            }}
            events={grids.grid1.events}
          />
        </SnResizeBar>
        <SnResizeBar direction={"width"} id="panel2" orgSize="76.5%">
          <SharedForm
            ref={sharedFormRef1}
            data={focusedRowData}
            controls={sharedForm}
            gridref={gridRefs.current["grid1"]}
            title="상세정보"
            onValueChaged={onValueChaged}
          ></SharedForm>
          <SnFileHelper
            ref={fileHelperRef}
            onFileUploadSuccess={handleFileUploadSuccess}
          />
        </SnResizeBar>
      </div>
      <div style={{ display: "none" }}>
        <SnGrid
          ref={gridRefs.current["sheet1"]}
          columnConfig={grids.sheet1.columns}
          rowData={grids.sheet1.dataSource}
        />
      </div>
    </div>
  );
});

export default SN_MTL_PTY_REG_001;
